class Utilities {
  isVisible(element) {
    return (
      element.offsetWidth > 0 ||
      element.offsetHeight > 0 ||
      window.getComputedStyle(element).display !== "none"
    );
  }

  windowBreakPoint() {
    const mainElement = document.querySelector('.main');

    if (mainElement) {
      const mainWidth = mainElement.clientWidth;
      const mobile = mainWidth < 582;
      const tablet = mainWidth >= 582 && mainWidth < 955;
      const desk = mainWidth >= 955;

      return mobile ? 'mobile' : tablet ? 'tablet' : 'desk';
    }
  };
};

const compareMembershipHidden = 'compare-membership__hidden'

const removeHide= function(colACell,colBCell,colCCell,colDCell,selectedValue){
  switch (selectedValue)
  {
    case "everyday":
      colACell.classList.remove(compareMembershipHidden);
      break;
    case "basic":
    case "classic":
      colBCell.classList.remove(compareMembershipHidden);
      break;
    case "plus":
      colCCell.classList.remove(compareMembershipHidden);
      break;
    case "premier":
        colDCell.classList.remove(compareMembershipHidden);
      break;
    default:
      break;
  }
};

const compareMembership = {
  version: '1.0.1',
  author: 'CAASCO Digital Operations',
  project: 'Compare Membership',
  Date: '2023',

  // -------------------- INITIALIZATION --------------------
  init: function() {
    const context = this;
    const selectBoxA = document.querySelector('#selectBoxA');
    const everydayOption = selectBoxA.querySelector('option[value="everyday"]');
    const basicOption = selectBoxA.querySelector('option[value="basic"]')==null?selectBoxA.querySelector('option[value="classic"]'):selectBoxA.querySelector('option[value="basic"]');
    const plusOption = selectBoxA.querySelector('option[value="plus"]');
    const premierOption = selectBoxA.querySelector('option[value="premier"]');

    // GLOBAL VARIABLES --------------------
    context.utilities = new Utilities();
    context.config = {
      prevViewport: '',
      defaultDropDownOptions: {
        mobile: {
          selectBoxB: {
            position: 1,
            list: [{
                option: everydayOption,
                isSelected: false
              },
              {
                option: basicOption,
                isSelected: true
              },
              {
                option: premierOption,
                isSelected: false
              }
            ]
          },
          selectBoxC: {
            position: 2,
            list: [{
                option: everydayOption,
                isSelected: false
              },
              {
                option: plusOption,
                isSelected: true
              },
              {
                option: premierOption,
                isSelected: false
              }
            ]
          }
        },
        tablet: {
          selectBoxB: {
            position: 1,
            list: [{
                option: everydayOption,
                isSelected: false
              },
              {
                option: basicOption,
                isSelected: true
              }
            ]
          },
          selectBoxC: {
            position: 2,
            list: [{
                option: everydayOption,
                isSelected: false
              },
              {
                option: plusOption,
                isSelected: true
              }
            ]
          },
          selectBoxD: {
            position: 3,
            list: [{
                option: everydayOption,
                isSelected: false
              },
              {
                option: premierOption,
                isSelected: true
              }
            ]
          }
        }
      },
      rvOptionsHolder: document.querySelectorAll('.rvOption input'),
      cardDropDowns: document.querySelectorAll("select"),
      topCards: document.querySelectorAll("div.card[data-parentcard]"),
      accCols: [].slice.call(document.querySelectorAll('.accordion__section')),
    };

    /*
     * Updates the URLs for the Plus and Premier membership CTAs based on the state of the RV checkboxes and the user's location (Manitoba or default).
     */
    const baseUrl = window.location.origin;
    const isManitoba = document.title.toLowerCase().includes('manitoba' || 'caamanitoba');
    const plusRvCheckbox = document.getElementById('ab-rv');
    const premierRvCheckbox = document.getElementById('ab-rv-prem');

    let plusCtaHref = document.getElementById('compare-cards__cta--plus');
    let premierCtaHref = document.getElementById('compare-cards__cta--premier');

    const MEMBERSHIP_TYPES = {
      MB: {
        PLUS: 'MB_PLUS',
        PLUS_RV: 'MB_PLUSRV',
        PREMIER: 'MB_PREMIER',
        PREMIER_RV: 'MB_PREMIERRV'
      },
      DEFAULT: {
        PLUS: 'Plus',
        PLUS_RV: 'PlusRv',
        PREMIER: 'Premier',
        PREMIER_RV: 'PremierRV'
      }
    };

    const {
      MB,
      DEFAULT
    } = MEMBERSHIP_TYPES;

    const generateMembershipUrl = (baseUrl, type) => `${baseUrl}/membership/Join?Type=${type}`;
    const membershipType = isManitoba ? MB : DEFAULT;
    const updateMembershipUrls = () => {
      plusCtaHref.href = generateMembershipUrl(
        baseUrl,
        plusRvCheckbox.checked ? membershipType.PLUS_RV : membershipType.PLUS
      );

      premierCtaHref.href = generateMembershipUrl(
        baseUrl,
        premierRvCheckbox.checked ? membershipType.PREMIER_RV : membershipType.PREMIER
      );
    };
    updateMembershipUrls();

    // CALL DOM INVOKING FUNCTIONS HERE --------------------
    context.onDomReady();
    context.eventHandlers();
  },

  // Reset UI
  resetUI: function() {
    const context = this;
    document.querySelectorAll('[data-parentcard]').forEach(elem => {
      elem.classList.remove(compareMembershipHidden, "hidden-sm", "hidden-md");
      elem.style.removeProperty("order");
    });
  },

  // hide rows when all visible cells contain no information ("-")
  checkEmptyRows: function() {
    const context = this;
    const accordionColumns = context.config.accCols;
    const isMobileOrTablet = context.utilities.windowBreakPoint();

    accordionColumns.forEach(accordion => {
      const accordionRows = accordion.querySelectorAll('.row');
      accordionRows.forEach(row => {
        let isRowBlank = true;

        let rowCells;
        if (isMobileOrTablet === 'tablet') {
          rowCells = row.querySelectorAll('[role="cell"]:not(.hidden-md)');
        } else {
          rowCells = row.querySelectorAll('[role="cell"]:not(.hidden-sm)');
        }

        rowCells.forEach(cell => {

          if (context.utilities.isVisible(cell) && !cell.querySelector('.contentHolder .sr-only')) {
            isRowBlank = false;
            return;
          }
        });

        if (isRowBlank) {
          row.classList.add('hidden-row');
        } else {
          row.classList.remove('hidden-row');
        }

        var colACell = row.querySelector('div.colA[role="cell"]');
        var colBCell = row.querySelector('div.colB[role="cell"]');
        var colCCell = row.querySelector('div.colC[role="cell"]');
        var colDCell = row.querySelector('div.colD[role="cell"]');

        colACell.classList.add(compareMembershipHidden);
        colBCell.classList.add(compareMembershipHidden);
        colCCell.classList.add(compareMembershipHidden);
        colDCell.classList.add(compareMembershipHidden);
        
        if (isMobileOrTablet === 'tablet' && colACell!=null && colACell.classList!=null) {
          var selectedValueB=document.querySelector('#selectBoxB').value
          var selectedValueC=document.querySelector('#selectBoxC').value
          var selectedValueD=document.querySelector('#selectBoxD').value
          removeHide(colACell,colBCell,colCCell,colDCell,selectedValueB);
          removeHide(colACell,colBCell,colCCell,colDCell,selectedValueC);
          removeHide(colACell,colBCell,colCCell,colDCell,selectedValueD);
        }
        else if (isMobileOrTablet === 'mobile' && colDCell!=null && colDCell.classList!=null)
        {
          var selectedValueB=document.querySelector('#selectBoxB').value
          var selectedValueC=document.querySelector('#selectBoxC').value
          removeHide(colACell,colBCell,colCCell,colDCell,selectedValueB);
          removeHide(colACell,colBCell,colCCell,colDCell,selectedValueC);
        }
        else if (isMobileOrTablet === 'desk' && colDCell!=null && colDCell.classList!=null)
        {
            colACell.classList.remove(compareMembershipHidden);
            colBCell.classList.remove(compareMembershipHidden);
            colCCell.classList.remove(compareMembershipHidden);
            colDCell.classList.remove(compareMembershipHidden);
        }

      });
    });
  },


  // Hide all card
  hideAllCard: function() {
    const context = this;
    context.config.topCards.forEach((card) => card.classList.add(compareMembershipHidden));
  },

  // Hide all accordion cells
  hideAllAccordionValues: function() {
    document.querySelectorAll('div[role="cell"]').forEach((cell) => cell.classList.add(compareMembershipHidden));
  },

  // Filter Dropdown item list
  filterDropDownList: function(selectedDD, restDropDowns) {
    const context = this;

    const otherOptionsFromSelectedDD = selectedDD.querySelectorAll(
      "option:not(option:checked)"
    );

    restDropDowns.forEach((restDD) => {
      if (context.utilities.isVisible(restDD)) {
        restDD
          .querySelectorAll("option:not(option:checked)")
          .forEach((option) => option.remove());

        otherOptionsFromSelectedDD.forEach((otherOption) => {
          if (context.utilities.isVisible(otherOption)) {
            if (otherOption.hasAttribute("selected")) {
              otherOption.removeAttribute("selected");
            }
            restDD.appendChild(otherOption.cloneNode(true));
          }
        });
      }
    });
  },

  // Set active card and Cells classes
  setActiveCardAndCells: function(selectedDropDownVal, selectedDDPosition) {
    const selectedCard = document.querySelector(`[data-parentcard="${selectedDropDownVal}"]`);
    const selectedCardCells = document.querySelectorAll(`div[role="cell"][data-parentcard="${selectedDropDownVal}"]`);

    selectedCard.classList.remove(compareMembershipHidden, "hidden-sm", "hidden-md");
    selectedCard.style.order = selectedDDPosition;

    selectedCardCells.forEach(cell => {
      cell.classList.remove(compareMembershipHidden, "hidden-sm", "hidden-md");
      cell.style.order = selectedDDPosition;
    });
  },

  // Set rest of the card status
  setRestCardsAndCells: function(restDropDowns) {
    const context = this;
    restDropDowns.forEach((restDD) => {
      if (context.utilities.isVisible(restDD)) {
        const position = restDD.dataset.position;
        const relatedCard = document.querySelector(
          `[data-parentcard="${restDD.value}"]`
        );
        const relatedCardCells = document.querySelectorAll(`div[role="cell"][data-parentcard="${restDD.value}"]`);

        relatedCard.classList.remove(compareMembershipHidden, "hidden-sm", "hidden-md");
        relatedCard.style.order = position;

        relatedCardCells.forEach(cell => {
          cell.classList.remove(compareMembershipHidden, "hidden-sm", "hidden-md");
          cell.style.order = position;
        });
      }
    });
  },

  // Build default dropdown options
  buildCardDropDown: function(mobileOrTablet) {
    const context = this;
    const defaultListOfDropDowns = context.config.defaultDropDownOptions[mobileOrTablet];

    Object.keys(defaultListOfDropDowns).forEach(dropdownID => {
      const dropdownElem = document.querySelector(`#${dropdownID}`);
      const {
        list: defaultOptionList,
        position: ddPosition
      } = defaultListOfDropDowns[dropdownID];

      // Empty Dropdown
      dropdownElem.innerHTML = '';

      // Append default items
      defaultOptionList.forEach(ddOption => {
        const {
          option,
          isSelected
        } = ddOption;

        const clonedOption = option.cloneNode(true);

        if (isSelected) {
          clonedOption.setAttribute('selected', isSelected);
          context.setActiveCardAndCells(clonedOption.value, ddPosition);
        }
        dropdownElem.innerHTML += clonedOption.outerHTML;
      });
    });
  },

  // ------------ HANDLE PAGE LOAD LEVEL TASK --------------------
  onDomReady: function() {
    // Force sticky select box
    const scrollContainer = document.querySelector('.scroll-container');

    if (scrollContainer) {
      scrollContainer.style.overflowX = 'initial';
    }
  },

  // Handle All card and cells
  handleAllCardAndCells: function(selectedDDValue, ddPosition, restDropDowns) {
    const context = this;

    // Hide all columns
    context.hideAllCard();

    // Hide all accordion values
    context.hideAllAccordionValues();

    // Set selected Card and related cells position
    context.setActiveCardAndCells(selectedDDValue, ddPosition);

    // Set Rest of cards position
    context.setRestCardsAndCells(restDropDowns);
  },

  // -------------------- HANDLE ALL PAGE LEVEL EVENTS --------------------
  eventHandlers: function() {
    const context = this;

    // ----- Handle RV checkbox change -----
    context.config.rvOptionsHolder.forEach((element) => {
      element.addEventListener('change', (event) => {
        const targetCheckId = event.target.id;
        const baseUrl = window.location.origin;
        const isManitoba = baseUrl.toLowerCase().includes('manitoba') ? true : false;
        const plusUrl = isManitoba ? `${baseUrl}/membership/Join?Type=MB_PLUS` : `${baseUrl}/membership/Join?Type=Plus`;
        const plusUrlRv = isManitoba ? `${baseUrl}/membership/Join?Type=MB_PLUSRV` : `${baseUrl}/membership/Join?Type=PlusRv`;
        const premierUrl = isManitoba ? `${baseUrl}/membership/Join?Type=MB_PREMIER` : `${baseUrl}/membership/Join?Type=Premier`;
        const premierUrlRv = isManitoba ? `${baseUrl}/membership/Join?Type=MB_PREMIERRV` : `${baseUrl}/membership/Join?Type=PremierRV`;
        const plusCtaHref = document.getElementById('compare-cards__cta--plus');
        const premierCtaHref = document.getElementById('compare-cards__cta--premier');

        const handleRvCheckbox = (targetCta, targetCtaUrl) => {
          targetCta.href = targetCtaUrl;
        };

        switch (targetCheckId) {
          case 'ab-rv-prem':
            if (event.target.checked) {
              handleRvCheckbox(premierCtaHref, premierUrlRv);
            } else {
              handleRvCheckbox(premierCtaHref, premierUrl);
            }
            break;

          default:
            if (event.target.checked) {
              handleRvCheckbox(plusCtaHref, plusUrlRv);
            } else {
              handleRvCheckbox(plusCtaHref, plusUrl);
            }
            break;
        }
      });
    });

    // ----- Card Dropdown change event -----
    context.config.cardDropDowns.forEach((dropDown) => {
      if (context.utilities.isVisible(dropDown)) {
        const ddPosition = dropDown.dataset.position;

        dropDown.addEventListener("change", (event) => {
          const selectedDD = event.target;
          const restDropDowns = document.querySelectorAll(
            `select[data-position]:not([data-position="${ddPosition}"])`
          );

          // Filter dropdown list
          context.filterDropDownList(selectedDD, restDropDowns);

          // Handle All Card and cells
          context.handleAllCardAndCells(selectedDD.value, ddPosition, restDropDowns);

          // Check for empty rows inside Accordion
          context.checkEmptyRows();
        });
      }
    });
  },

  // Listen to viewport change
  handleViewportChange: function() {
    const context = this;
    const isMobileOrTablet = context.utilities.windowBreakPoint();

    if (context.config.prevViewport === isMobileOrTablet) {
      return;
    }

    context.config.prevViewport = isMobileOrTablet;

    if (isMobileOrTablet === 'desk') {
      // Reset page UI
      context.resetUI();
    } else {
      // Hide all columns
      context.hideAllCard();

      // Hide all accordion values
      context.hideAllAccordionValues();

      // Build dropdown
      context.buildCardDropDown(isMobileOrTablet);

      // Check for empty rows
      context.checkEmptyRows();
    }
  },
};

// -------------------- LOAD init() --------------------
window.addEventListener('load', () => {
  if ( document.querySelector('#compare-membership__select-holder')!=null)
  {
    compareMembership.init();
    compareMembership.checkEmptyRows();
    compareMembership.handleViewportChange();
  }
});

window.addEventListener('resize', () => {
  if ( document.querySelector('#compare-membership__select-holder')!=null)
  {
    compareMembership.handleViewportChange();
  }
});

window.addEventListener('orientationchange', () => {
  if ( document.querySelector('#compare-membership__select-holder')!=null)
  {
    setTimeout(() => {
      compareMembership.init();
      compareMembership.checkEmptyRows();
      compareMembership.handleViewportChange();
    }, 500);
  }
});
